import * as types from "./../../store/mutation-types.js";
import * as globalMutationTypes from "@/store/mutation-types.js";

import icons from "@/mixins/icons.js";
import bo from "@/mixins/basic-operations.js";
import ValidationService from "@/services/validation.service.js";
import AS from "./../../services/agenda-global/agenda.service.js";
import _ from "lodash";
import { GridPlugin, Aggregate, Group, Page } from "@syncfusion/ej2-vue-grids";

import RSM from "wisaapp-webstudent/src/mixins/right-side-menu.js";
import { getAccountInfo } from "../../store/actions.js";
// import tab from "@/components/utils/tab/tab.vue";
// import { data } from "./../Aanwezigheden/datasource";

const agendaService = new AS();

const validationService = new ValidationService();
export default {
  name: "Module",
  mixins: [icons, bo, RSM],
  // components: {
  //   // tab
  // },
  data: function () {
    return {
      /********grid grouping****** */
      // data:data.slice(0, 7),
      // groupSettings: {
      //   captionTemplate: "<div>${format(data)}</div> ",
      //   columns: ["Moduleomschrijving", "Resultaat", "LoopbaanVan"]
      // },
      /********************************************************** */
      screenRights: this.$store.state.userInfo.screensRightsInformation,
      cursistInfo: this.$store.state.wstudent.cursistInfo,
      // moduleList: this.$store.state.wstudent.moduleList,
      // gevolgdemoduleList: this.$store.state.wstudent.gevolgdeopleidingOpleidingList,
      currentOpleiding: this.$store.state.wstudent.currentOpleiding,
      // currentModules: [],
      selectedToestand: "",
      sortby: [["LoopbaanVan", "Resultaat", 'Moduleomschrijving'], ['asc', 'desc', 'asc']]
      // currentAllCombinedModules:[]
    };
  },
  // provide: {
  //   grid: [Page, Aggregate, Group]
  // },

  created: function () {
    this.$store.commit("wstudent/" + types.ZET_CURRENT_SCREEN, "Module");
  },
  beforeCreate: function () {
    // eslint-disable-next-line
  },
  computed: {
    getcursistInfo() {
      return this.cursistInfo;
    },
    currentModules() {
     let moduleList= this.$store.getters["wstudent/getFilteredModules"](this.currentOpleiding, this.selectedToestand, this.sortby)

     const grouped = moduleList.reduce((acc, item) => {
      if (!acc[item.ModuleID]) acc[item.ModuleID] = [];
      acc[item.ModuleID].push(item);
      return acc;
    }, {});

// Step 2: Filter out duplicates with no Resultaat and bg-light
const filtered = Object.values(grouped).flatMap(group => {
  if (group.length === 1) return group;

  return group.filter(item =>
    item.Resultaat || item.colorReference !== 'bg-light'
  );
});

// Step 3: Sort with Resultaat-first logic
return filtered.sort((a, b) => {
  const hasResultA = !!a.Resultaat;
  const hasResultB = !!b.Resultaat;
  return hasResultB - hasResultA; // true - false = -1 => sort A before B
});


      // return this.$store.getters["wstudent/getFilteredModules"](this.currentOpleiding, this.selectedToestand, this.sortby);

    },
  },
  watch: {},
  mounted: function () {
    this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
      changePartially: true,
      left: "back",
      title: this.currentOpleiding.Opleidingsvariantomschrijving,
      right: []
    });
    // this.allCombinedModules= this.moduleList.concat(this.gevolgdemoduleList);
    // this.updatecurrentAllModules(this.currentOpleiding);
  },

  methods: {
    sort(value) {
      let a = ''
      let temp = []
      for (let i = 0; i < this.sortby[1].length; i++) {
        if (this.sortby[1][i] === 'asc') {
          a = 'desc'
        } else {
          a = 'asc'
        }
        temp.push(a)

      }
      this.sortby = [[value], temp]


    },
    // updatecurrentAllModules(currentOpleiding) {
    //   this.currentModules = this.moduleList.filter(function(value) {
    //     return value.ModuleID === currentOpleiding.ModuleID;
    //   });
    //   let filtergelvolgdeopleiding = this.gevolgdemoduleList.filter(function(value) {
    //     return value.OpleidingsvariantID === currentOpleiding.OpleidingsvariantID;
    //   });
    //   this.currentModules = this.currentModules.concat(filtergelvolgdeopleiding);
    // },
    filterToestand() {
      console.log(this.selectedToestand);
      let a = [];


    }
  }

};
// window.format = function(value) {
//   debugger;
//   var x = value.count;
//   if (x > 1) {
//     x = value.count + "items";
//   } else {
//     x = value.count + "item";
//   }
//   switch (value.field) {
//     case "Moduleomschrijving":
//       if (value.items.level) {
//         return value.items.records[0].ShipCountry;
//       } else {
//         return value.items[0].ShipCountry;
//       }
//     case "Resultaat":
//       if (value.items.level) {
//         return x;
//       } else {
//         return x;
//       }
//     case "LoopbaanVan":
//       if (value.items.level) {
//         return value.items.records[0][value.field];
//       } else {
//         return value.items[0][value.field];
//       }
//     default:
//       return value.field + ": " + value.key + " " + x;
//   }
// };